import { EmailStepSchema } from '@feedyou-ai/feedbot-schema'
import { Mutable, SelectedMutations } from '@feedyou/utils'

import { Action, actionTypes } from './actions'
import { updateStepMutation } from '../../Step/StepService'

export function emailReducer(
  step: Mutable<EmailStepSchema>,
  action: Action,
  selectedMutations: SelectedMutations
) {
  switch (action.type) {
    case actionTypes.SET_SUBJECT:
      if (selectedMutations) {
        return updateStepMutation(step, 'subject', action.subject || '', selectedMutations)
      }

      return { ...step, subject: action.subject }

    case actionTypes.SET_RECIPIENT:
      if (selectedMutations) {
        return updateStepMutation(step, 'recipient', action.recipient || '', selectedMutations)
      }

      return { ...step, recipient: action.recipient }

    case actionTypes.SET_CC_RECIPIENTS:
      if (selectedMutations) {
        return updateStepMutation(step, 'ccRecipient', action.ccRecipient || '', selectedMutations)
      }

      return { ...step, ccRecipient: action.ccRecipient }

    case actionTypes.SET_BODY:
      if (selectedMutations) {
        return updateStepMutation(step, 'body', action.body || '', selectedMutations)
      }

      return { ...step, body: action.body }

    default:
      return step
  }
}
